import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "./Layout";
import "../assets/css/Parametros.css";
import { FaEye } from "react-icons/fa";
import { getParametros, getCurrentUser } from "../services/API";
import Select from "react-select";
import { Modal, Button } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';

const Parametros = () => {
    const navigate = useNavigate();
    const [selectedOption, setSelectedOption] = useState(null);
    const [todosParametros, setAllParametros] = useState([]);
    const [parametrosFiltrados, setParametrosFiltrados] = useState([]);
    const [busqueda, setBusqueda] = useState("");
    const [filtroPropietario, setFiltroPropietario] = useState("propios");
    const [usuarioActualId, setUsuarioActualId] = useState(null);
    const [filtrosAplicados, setFiltrosAplicados] = useState({});
    const [showModal, setShowModal] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [modalOptions, setModalOptions] = useState([]);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
    const [paginaActual, setPaginaActual] = useState(1);
    const [invitado, setInvitado] = useState(false);
    const elementosPorPagina = 10;

    const formatDateTime = (dateString) => {
        const date = new Date(dateString);
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, "0");
        const dd = String(date.getDate()).padStart(2, "0");
        const hh = String(date.getHours()).padStart(2, "0");
        const min = String(date.getMinutes()).padStart(2, "0");
        const ss = String(date.getSeconds()).padStart(2, "0");

        return `${yyyy}-${mm}-${dd} ${hh}:${min}:${ss}`;
    };

    const handleApplyFilter = () => {
        setShowModal(false);
        setFiltrosAplicados(prev => ({
            ...prev,
            [modalTitle]: selectedOption
        }));
        setSelectedOption(null);
    };

    const handleDetalles = (id) => {
        localStorage.setItem("parametro", id);
        navigate("/editar-parametro");
    };

    const handleSort = (key) => {
        let direction = "asc";
        if (sortConfig.key === key && sortConfig.direction === "asc") {
            direction = "desc";
        }
        setSortConfig({ key, direction });
    };

    const sortData = (data, config) => {
        if (!config.key) {
            return data;
        }

        const sortedData = [...data].sort((a, b) => {
            const aValue = a[config.key];
            const bValue = b[config.key];

            if (aValue == null && bValue == null) return 0;
            if (aValue == null) return 1;
            if (bValue == null) return -1;

            if (['created_at', 'updated_at'].includes(config.key)) {
                const dateA = new Date(aValue);
                const dateB = new Date(bValue);

                if (dateA < dateB) {
                    return config.direction === "asc" ? -1 : 1;
                }
                if (dateA > dateB) {
                    return config.direction === "asc" ? 1 : -1;
                }
                return 0;
            }
            else {
                const strA = String(aValue).toLowerCase();
                const strB = String(bValue).toLowerCase();

                if (strA < strB) {
                    return config.direction === "asc" ? -1 : 1;
                }
                if (strA > strB) {
                    return config.direction === "asc" ? 1 : -1;
                }
                return 0;
            }
        });
        return sortedData;
    };

    const columnas = [
        "Destiny", "Section"
    ];

    const opcionesModal = {
        "Section": ["RISK", "NEUTRAL", "SECURE"],
        "Destiny": ["AdGroups", "Campaigns", "Portfolios", "Asins"],
    };

    const handleSelectChange = (selected) => {
        const columna = selected.value;
        if (opcionesModal[columna]) {
            setModalTitle(columna);
            setModalOptions(opcionesModal[columna]);
            setShowModal(true);
        }
    };

    const opcionesFiltrado = columnas.map((columna) => ({
        label: columna,
        value: columna,
    }));

    const convertirParametros = (parametros) => {
        const segmentationMap = {
            1: "RISK",
            2: "NEUTRAL",
            3: "SECURE"
        };

        const destinationMap = {
            1: "AdGroups",
            2: "Campaigns",
            3: "Portfolios",
            4: "Asins"
        };

        return parametros.map((param) => ({
            ...param,
            updated_at: formatDateTime(param.updated_at),
            created_at: formatDateTime(param.created_at),
            seccion: segmentationMap[param.segmentation_id] || param.segmentation_id,
            destino: destinationMap[param.destination_id] || param.destination_id
        }));
    };

    useEffect(() => {
        (async () => {
            const currentUser = await getCurrentUser();
            setInvitado(currentUser.userRolesId === 4 ? true : false)
            const accountID = localStorage.getItem("selectedAccountValue");
            const response = await getParametros(accountID);
            const parametrosConvertidos = convertirParametros(response.data);
            setUsuarioActualId(response.id);
            setAllParametros(parametrosConvertidos);
            setFiltroPropietario("propios");
        })();
    }, []);

    useEffect(() => {
        if (usuarioActualId === null) return;

        let filtrados = todosParametros.filter(param =>
            filtroPropietario === "propios" ? param.users_id === usuarioActualId : param.users_id !== usuarioActualId
        );

        for (const columna in filtrosAplicados) {
            if (filtrosAplicados.hasOwnProperty(columna) && filtrosAplicados[columna]) {
                filtrados = filtrados.filter(param => {
                    if (columna === "Section") {
                        return param.seccion === filtrosAplicados[columna];
                    }
                    if (columna === "Destiny") {
                        return param.destino === filtrosAplicados[columna];
                    }
                    return true;
                });
            }
        }

        filtrados = sortData(filtrados, sortConfig);

        setParametrosFiltrados(filtrados);
        setPaginaActual(1);
    }, [filtroPropietario, todosParametros, usuarioActualId, filtrosAplicados, sortConfig]);

    const handleRedirigir = () => navigate("/anadir-parametro");

    const resultadosBusqueda = parametrosFiltrados.filter(param => {
        const valores = Object.values(param)
            .map(val => {
                if (val === null || val === undefined) return "";
                if (typeof val === "object") return JSON.stringify(val);
                return String(val);
            })
            .join(" ")
            .toLowerCase();
        return valores.includes(busqueda.toLowerCase());
    });


    const indiceUltimo = paginaActual * elementosPorPagina;
    const indicePrimero = indiceUltimo - elementosPorPagina;
    const parametrosVisibles = resultadosBusqueda.slice(indicePrimero, indiceUltimo);
    const totalPaginas = Math.ceil(resultadosBusqueda.length / elementosPorPagina);

    return (
        <Layout>
            <div className="app-container">
                <div className="content-containerParametros">
                    <div className="parametros-container">
                        <h2>Segmentation Parameters - Customer Search Term</h2>

                        <div className="w-100 d-flex justify-content-center align-items-center">
                            <button className={`btn btn-primary mx-2 mb-4 ${filtroPropietario === "propios" ? "activo" : ""}`}
                                onClick={() => setFiltroPropietario("propios")}
                            >
                                My parameters
                            </button>
                            <button className={`btn btn-secondary mx-2 mb-4 ${filtroPropietario === "otros" ? "activo" : ""}`}
                                onClick={() => setFiltroPropietario("otros")}
                            >
                                Other parameters
                            </button>
                        </div>
                        <div className="buscador-container">
                            <input
                                type="text"
                                placeholder="Search by parameter name"
                                value={busqueda}
                                onChange={(e) => {
                                    setBusqueda(e.target.value);
                                    setPaginaActual(1);
                                }}
                                className="buscador-input"
                            />

                            <div style={{ minWidth: "250px" }}>
                                <Select
                                    options={opcionesFiltrado}
                                    placeholder="Filter by..."
                                    isSearchable
                                    onChange={handleSelectChange}
                                    styles={{
                                        control: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: "#ffeeba",
                                            border: "1px solid #e0a800",
                                            boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(255, 193, 7, 0.25)" : null,
                                            "&:hover": {
                                                borderColor: "#e0a800"
                                            }
                                        }),
                                        valueContainer: (provided) => ({
                                            ...provided,
                                            color: "#212529"
                                        }),
                                        singleValue: (provided) => ({
                                            ...provided,
                                            color: "#212529"
                                        }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isSelected ? "#ffeeba" : "#fff",
                                            color: state.isSelected ? "#000" : "#212529"
                                        })
                                    }}
                                />
                            </div>

                            <Modal style={{ zIndex: 10000 }} show={showModal} onHide={() => setShowModal(false)}>
                                <Modal.Header closeButton>
                                    <Modal.Title>Filter by {modalTitle}</Modal.Title>
                                </Modal.Header>

                                <Modal.Body style={{ minHeight: "150px", height: "auto" }}>
                                    <select
                                        className="form-select"
                                        value={selectedOption}
                                        onChange={(e) => setSelectedOption(e.target.value)}
                                    >
                                        <option value="">Select an option</option>
                                        {modalOptions.map((opcion, i) => (
                                            <option key={i} value={opcion}>{opcion}</option>
                                        ))}
                                    </select>
                                </Modal.Body>

                                <Modal.Footer>
                                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                                        Close
                                    </Button>
                                    <Button
                                        variant="primary"
                                        onClick={handleApplyFilter}
                                        disabled={!selectedOption && modalTitle !== "Report Date"}
                                    >
                                        Apply
                                    </Button>
                                </Modal.Footer>
                            </Modal>

                            <button className="btn-anadir" disabled={invitado} onClick={handleRedirigir}>
                                Add
                            </button>
                        </div>
                        <div className="d-flex gap-2 flex-wrap my-3">
                            {Object.entries(filtrosAplicados).map(([key, value]) => (
                                <span key={key} className="badge bg-primary text-white d-flex align-items-center gap-2 px-3 py-2 rounded-pill">
                                    {typeof value === 'object' && value !== null && value.hasOwnProperty('option') && value.hasOwnProperty('value') ? (
                                        `${key}: ${value.option} ${value.value}`
                                    ) : (
                                        `${key}: ${value}`
                                    )}
                                    <button
                                        className="btn btn-sm btn-light border-0"
                                        onClick={() => {
                                            const nuevo = { ...filtrosAplicados };
                                            delete nuevo[key];
                                            setFiltrosAplicados(nuevo);
                                        }}
                                    >
                                        x
                                    </button>
                                </span>
                            ))}
                        </div>
                        <table className="tabla-parametros">
                            <thead>
                                <tr>
                                    <th className="px-2 py-3 text-center" style={{ fontSize: "0.9rem", cursor: "pointer" }} onClick={() => handleSort('seccion')}>
                                        Section {sortConfig.key === 'seccion' ? (sortConfig.direction === 'asc' ? '^' : 'v') : ''}
                                    </th>
                                    <th className="px-2 py-3 text-center" style={{ fontSize: "0.9rem", cursor: "pointer" }} onClick={() => handleSort('name')}>
                                        Name {sortConfig.key === 'name' ? (sortConfig.direction === 'asc' ? '^' : 'v') : ''}
                                    </th>
                                    <th className="px-2 py-3 text-center" style={{ fontSize: "0.9rem", cursor: "pointer" }} onClick={() => handleSort('destino')}>
                                        Destiny {sortConfig.key === 'destino' ? (sortConfig.direction === 'asc' ? '^' : 'v') : ''}
                                    </th>
                                    <th className="px-2 py-3 text-center" style={{ fontSize: "0.9rem", cursor: "pointer" }} onClick={() => handleSort('created_at')}>
                                        Date Created {sortConfig.key === 'created_at' ? (sortConfig.direction === 'asc' ? '^' : 'v') : ''}
                                    </th>
                                    <th className="px-2 py-3 text-center" style={{ fontSize: "0.9rem", cursor: "pointer" }} onClick={() => handleSort('updated_at')}>
                                        Date Updated {sortConfig.key === 'updated_at' ? (sortConfig.direction === 'asc' ? '^' : 'v') : ''}
                                    </th>
                                    <th className="px-2 py-3 text-center" style={{ fontSize: "0.9rem" }}>Details</th>
                                </tr>
                            </thead>
                            <tbody>
                                {parametrosVisibles.map(param => (
                                    <tr key={param.id}>
                                        <td className={`py-2 px-3 text-dark ${param.seccion.toLowerCase()} text-dark`}>{param.seccion}</td>
                                        <td className="py-2 px-3">{param.name}</td>
                                        <td className="py-2 px-3">{param.destino}</td>
                                        <td className="py-2 px-3">{param.created_at}</td>
                                        <td className="py-2 px-3">{param.updated_at}</td>
                                        <td className="py-2 px-3 text-center">
                                            <button onClick={() => handleDetalles(param.id)} className="btn btn-primary">
                                                <FaEye /> <span className="mx-1 mt-2">View Details</span>
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        {totalPaginas > 1 && (
                            <div className="paginacion">
                                <button
                                    onClick={() => setPaginaActual(prev => Math.max(prev - 1, 1))}
                                    disabled={paginaActual === 1}
                                >
                                    &laquo;
                                </button>

                                {[...Array(totalPaginas)].map((_, i) => (
                                    <button
                                        key={i + 1}
                                        className={paginaActual === i + 1 ? "activo" : ""}
                                        onClick={() => setPaginaActual(i + 1)}
                                    >
                                        {i + 1}
                                    </button>
                                ))}

                                <button
                                    onClick={() => setPaginaActual(prev => Math.min(prev + 1, totalPaginas))}
                                    disabled={paginaActual === totalPaginas}
                                >
                                    &raquo;
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default Parametros;